import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core'
import { GuestRoutingModule } from './guest-routing.module';
import { LoginComponent } from './login/login.component';
import { SharedService } from '../../services/shared.service';
import { ReactiveFormsModule } from '@angular/forms';
import { ForgotComponent } from './forgot/forgot.component';
import { RemoteComponent } from './remote/remote.component';
import { RemoteManagerComponent } from './remote-manager/remote-manager.component';
import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [
    LoginComponent,
    ForgotComponent,
    RemoteComponent,
    RemoteManagerComponent
  ],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    CommonModule,
    GuestRoutingModule,
    TranslateModule,
  ],
  providers: [
    SharedService,
  ],
})
export class GuestModule { }
